<template>
  <div class="login_box">
      <div class="login_title">春秋国旅同业分销登陆</div>



      <a-form
        :model="formState"
        name="normal_login"
      
        @finish="onFinish"       
      >
        <a-form-item
          name="username"
          
          :rules="[{ required: true, message: '请输入用户名' }]"
        >
          <a-input v-model:value="formState.username" placeholder="请输入账号">
            <template #prefix>
              <UserOutlined  />
            </template>
          </a-input>
        </a-form-item>

        <a-form-item
          name="password"
          :rules="[{ required: true, message: '请输入密码' }]"
        >
          <a-input-password v-model:value="formState.password"  placeholder="请输入密码" size="middle" autocomplete="off">
            <template #prefix>
              <LockOutlined />
            </template>
          </a-input-password>
        </a-form-item>

        <a-form-item>
          <a-button :disabled="loginLoading" type="primary"  :loading="loginLoading" html-type="submit" size="large"  shape="round" >
            登录
          </a-button>
        </a-form-item>
      </a-form>

      <div class="Quick_entry">
          <a href="#" @click="showFindPasswordModal">忘记密码</a><a href="/reg">免费注册</a>
      </div>
  </div>

    <a-modal v-model:open="findPasswordModal" title="重置密码" :confirm-loading="confirmLoading" @ok="handleOk">

      <a-space  direction="vertical" size="large" style="width: 100%">

        <a-input-group   >
            <a-input-password v-model:value="findPasswordData.Password"  placeholder="请输入新密码" />
        </a-input-group>

        <a-input-group  compact>    
          <a-input :addon-before="findPasswordData.Email" v-model:value="findPasswordData.VerificationCode" style="width: calc(100% - 130px)" />
          <a-button type="primary" :loading="loginLoading" @click="sendVerificationCode">发送验证码</a-button>
        </a-input-group>
        <a-input-group   >
             若总账号想更换绑定的验证邮箱，请与客户经理联系
        </a-input-group>

      </a-space>
    </a-modal>


</template>

<script>
import { UserOutlined, LockOutlined} from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import Cookies from 'js-cookie';
export default {
  name: 'LoginForm',
  data() {
      return {
        formState :{
            username: '',
            password: ''
          },
        findPasswordData :{
          LoginId: "",
          Email: "",
          VerificationCode: "",
          Password: ""
  
        },
        confirmLoading:false,
        findPasswordModal:false,
        hasLogin:false,
        memberData:{},
        loginLoading: false
      };
  },
  components:{
    UserOutlined,
    LockOutlined
  },
  mounted() {
    document.title = this.$route.meta.title;
    if(Cookies.get('token')){
      this.$router.push({ path: '/hotels' });
    }
  },
  methods: {
    async onFinish(){
     

      this.loginLoading = true;
          try {
              const response = await this.$axios.post('/Login/B2BPC', {
                  username: this.formState.username,
                  password: this.formState.password
              }, {
                  responseType: 'json',
                  withCredentials: true,
                  timeout: 5000
              });
              //console.log(response)
              if (response.data.RetCode == "Success") {
                //console.log( response.data.SessionId)
                // 存储token到cookie中
                 Cookies.set('token', response.data.SessionId, { expires: 1 }); // 1天过期
                  // 登录成功，执行相应操作
                 // alert('登录成功');
                  // 例如，重定向到酒店搜索页面
                   this.$router.push({ path: '/hotels' });
              } else {
                  // 登录失败，显示错误信息
                  message.error( response.data.RetMessage || '登录失败，请重试');

              }
          } catch (error) {
              message.error( '登录请求失败，请稍后重试');
              console.error('登录请求失败:', error);
          } finally {
              this.loginLoading = false;
          }




    },
    showFindPasswordModal(){

          if(this.formState.username==""){
            message.error('请输入用户名');
            return;
          }
         
          
                this.$axios.post('/memberContactEmail', {
                    LoginId: this.formState.username
                }, {
                    responseType: 'json',
                    withCredentials: true,
                    timeout: 5000
                })
                .then(response =>{     
                   
                  if (response.data.RetCode == "Success") {
                   console.log( response)
                    this.findPasswordData.Email=response.data.data[0].Email
                    this.findPasswordData.LoginId=this.formState.username
                    this.findPasswordModal=true;
                    console.log( this.findPasswordData)
                      
                  } else {
                    message.error( response.data.RetMessage || '请求失败，请重试');
                  }

                });
     
    },
    sendVerificationCode(){
       this.loginLoading = true;   
      this.$axios.post('/sendVerificationCode', {
          Operation: 1,
          Email: this.findPasswordData.Email
      }, {
          responseType: 'json',
          withCredentials: true,
          timeout: 5000
      })
      .then(response =>{   
        this.loginLoading = false;    
        if (response.data.RetCode == "Success") {
          message.success('验证码已发送至您的邮箱，请注意查收');
        } else {
          message.error( response.data.RetMessage || '请求失败，请重试');
        }

      });
    },

    async handleOk(){
      
      this.confirmLoading = true;
      try {

          if (this.findPasswordData.Password == "") {
              message.error('密码不能为空');
              this.confirmLoading = false;
              return;
          }
          if (this.findPasswordData.VerificationCode =="") {
              message.error('验证码不能为空');
              this.confirmLoading = false;
              return;
          }

        
          const response = await this.$axios.post('/resetPassword', this.findPasswordData, {
              responseType: 'json',
              withCredentials: true,
              timeout: 5000
          });
          console.log(response)
          if (response.data.RetCode == "Success") {
            this.editModaleOpen=false;
            Cookies.remove('etxing_'+Cookies.get('token')); // 1天过期
            this.$success({
              title: '恭喜您',
              content: response.data.RetMessage,
              okText: '确定',
              onOk() {
                window.location.reload(); 
              },
            });
          } else {
              // 登录失败，显示错误信息
              message.error( response.data.RetMessage || '操作失败，请重试');

          }
      } catch (error) {
          message.error( '操作失败，请重试');
          console.error('操作失败:', error);
      } finally {
          this.confirmLoading = false;
      }


      
    }


  }
};
</script>

<style scoped>

.ant-form-horizontal .ant-form-item .ant-input-affix-wrapper{
  line-height: 2.2 !important;
}

.ant-form-horizontal  .ant-btn-primary {
  width: 100%;
}

.login_box {
    position: absolute;
    top: -650px;
    right: 0;
    z-index: 99;
    width: 400px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 10px;
  }
  .login_box .login_title {
    text-align: center;
    line-height: 40px;
    font-size: 20px;
    background: #fff;
    margin: 14px 0;
  }
  .login_box form {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 300px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin: 0 auto;
  }




  .login_box .Quick_entry {
    height: 50px;
    line-height: 50px;
    width: 300px;
    text-align: right;
    margin: 0 auto;
    font-size: 14px;
  }

  .login_box .Quick_entry a:hover{text-decoration: underline}
  .login_box .Quick_entry a:nth-child(1) {
    margin-right: 10px;
    padding-right: 10px;
    border-right: 1px solid #eee;
  }
</style>
